module.exports = __webpack_public_path__ + "img/github.6f826d3b.svg";